/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
// import { toastEmmit } from "../../../../Helper/Toastr";
import { format } from "date-fns";
import { showErrorAlert, showSuccessAlert } from "../../../../Helper/SweetAlert";
import Switch from "@mui/material/Switch";
import MoonLoader from "react-spinners/MoonLoader";
import Pagination from "../../../../Helper/Pagination";

export default function Content() {
  const [ContentList, setContentList] = useState();
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [submitLoader, setsubmitLoader] = useState(false);

  const [selectedData, setSelectedData] = useState('');

  useEffect(() => {
    getContentList();
  }, [search_key, currentPage]);

  const getContentList = () => {
    setLoading(true);

    const param = {
      limit: 10,
      page: currentPage,
      sorting: "sortingKey|desc",
      search_key: search_key,
    };

    PostService(API_URL.GET_CONTENT_LIST, param).then((res) => {
      console.log(res);
      if (res?.data?.status === true) {
        setContentList(res.data.data.rows);
        SetTotalPageCount(res.data.totalPages);
        SetTotalCount(res.data.totalItems);
        setCount(res.data.currentPage * param.limit);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  const [error, setError] = useState(false);

  const [title, settitle] = useState("");
  const [content, setcontent] = useState( );
  const [status, setstatus] = useState("");

  useEffect(() => {
    settitle(selectedData?.title);
    setcontent(selectedData?.content);
    setstatus(selectedData?.status);
  }, [selectedData]);

  const submit = (e) => {
    e.preventDefault();

    if (!title || !content || !status) {
      setError(true);
      return;
    }

    setsubmitLoader(true)

    let formdata = {
      content_id: selectedData?.content_id,
      content,
      title,
      status,
    }; 

    PostService(API_URL.EDIT_CONTENT, formdata).then(
      (res) => {
        console.log(res);
        if (res.data.status === true) {
          showSuccessAlert(res?.data?.message, getContentList);  
          resetFunc();
          // getContentList();
          document.getElementById("closeEditModal").click();
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  const changeStatus = async (id, status) => {
    const data = {
      content_id: id,
      status: status === "active" ? "inactive" : "active",
    };

    PostService(API_URL.CHANGE_CONTENT_STATUS, data).then(
      (res) => {
        if (res.data.status) {
          showSuccessAlert(res?.data?.message, getContentList);
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  function resetFunc() { 
    setSelectedData(''); 
    setcontent('');   
    setstatus("");
    settitle("");
     setError(false);
    setsubmitLoader(false)
  }

  function dataobj(data) {
    console.log(data);
    console.log(content)
  } 
 

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3 className="default_color">Contents List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Contents List</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-md-4 offset-md-8 p-0">
                      <nav className="navbar">
                        <input
                          className="form-control"
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Keyword"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setsearch_key(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                  </div>

                  <div className="table-responsive">
                    {!loading && (
                      <table className="table table-hover text-nowrap table-striped table-bordered">
                        <thead>
                          <tr>
                            <th className="text-center">S.No</th>
                            <th className="text-center">Title</th>
                            <th className="text-center">Status</th>
                            <th className="text-center">Created-At</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ContentList?.map((data, i) => (
                            <tr key={i} className="text-center">
                              <td>{i + S_No_Count + 1}</td>
                              <td>{data?.title ? data?.title : "N/A"}</td>
                              <td className="text-center">
                                <span
                                  className={
                                    data?.status === "active"
                                      ? "badge badge-success"
                                      : "badge badge-danger"
                                  }
                                >
                                  {data?.status}
                                </span>
                              </td>
                              <td>
                                {format(new Date(data?.date), "dd/MM/yyyy")}
                              </td>
                              <td className="text-center">
                              <span className="toggle-switch">
                                    <Switch
                                      checked={data?.status === "active"}
                                      onChange={() => {
                                        changeStatus(
                                          data.content_id,
                                          data.status
                                        );
                                      }}
                                      size="small"
                                      color="primary" // You can customize the color
                                      inputProps={{
                                        "aria-label": "toggle switch",
                                      }}
                                    />
                                  </span>

                                {/* <Link
                                  title="View"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  to={`view/${data?._id}`}
                                >
                                  <i className="text-warning fas fa-eye"></i>
                                </Link> */}
                                <span
                                  title="Update"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  data-toggle="modal"
                                  data-target="#EditModal"
                                  onClick={() => {
                                    setSelectedData(data);
                                    dataobj(data);
                                  }}
                                >
                                  <i className="text-dark fas fa-pen"></i>{" "}
                                </span>
                              </td>
                            </tr>
                          ))}
                          {ContentList && ContentList.length === 0 && (
                              <tr>
                                <td colSpan="5" className="text-center">
                                  <h6 className="p-3"> No Data Found </h6>
                                </td>
                              </tr>
                            )}
                        </tbody>
                      </table>
                      )}
                     {loading ? (
                        <div className="LoaderSpinner">
                           <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                          <div>Loading... Please wait.</div>
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="mt-4">
                        <Pagination
                          counting={S_No_Count}
                          totaldata={TotalCount}
                          pagecount={TotalPageCount}
                          onChangePage={handlePageClick}
                          activePage={currentPage}
                        />
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        className="modal fade"
        id="EditModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLabel">
                Edit Content
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFunc}
              >
                {" "}
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={(e) => submit(e)}>
              <div className="modal-body">
                <div className="form-group">
                  <label>Title</label>
                  <input
                    type="text"
                    name="name"
                    value={title}
                    className="form-control"
                    onChange={(e) => settitle(e.target.value)}
                    placeholder="Title"
                  />
                  {error && !title && (
                    <div className="error">Title is required</div>
                  )}
                </div>

                <div className="form-group">
                  <label>Status</label>
                  <select
                    className="form-control"
                    value={status}
                    onChange={(e) => setstatus(e.target.value)}
                  >
                    <option value="" selected default hidden>
                      Select
                    </option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>

                  {error && !status && (
                    <div className="error">Status is required</div>
                  )}
                </div>

                <div className="form-group">
                  <label>Content</label>
                  <CKEditor
                    editor={ClassicEditor}
                    data={content?content:''}  
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setcontent(data);
                    }}
                  /> 
                  {error && !content && (
                    <div className="error">Content is required</div>
                  )}
                </div>

                
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  id="closeEditModal"
                  data-dismiss="modal"
                  onClick={resetFunc}
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary" 
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i> 
                  ) : 'Update' }
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
